import React from 'react'
import web2 from '../assets/web2.jpg';

function Home() {
    return (
        <section className="about-section py-5" >
            <div className="container" >
                {/* Title */}
                <div className="text-center mb-5">
                    <h2 className="fw-bold">Tamil Nadu Warehousing Corporation</h2>

                </div>
                <p className="text-muted">
                    Tamil Nadu Warehousing Corporation (TNWC) was established under the
                    Agriculture Produce (Development of Warehousing) Corporation Act 1956,
                    and commenced its activities on 2nd May 1958. Later its functioning came
                    under the purview of the Warehousing Corporation Act 1962. At present the
                    Tamil Nadu Warehousing Corporation is functioning throughout the State with
                    60 Warehouses territorially spread over 7 Regions with a Storage Capacity of
                    7.60 Lakh MTs.
                </p>

                <div className="row align-items-center g-5 my-4">
                    {/* LEFT CONTENT */}
                    <div className="col-md-6 m-0" data-aos="fade-right">
                        <div className="d-flex flex-column align-items-center gap-3">
                            <h6 className="fw-semibold mb-3">
                                Our motto is
                            </h6>
                            <h6 className="fw-semibold mb-3">
                                “To provide Scientific Storage facilities and
                            </h6>
                            <h6 className="fw-semibold mb-3">
                                To avoid wastage of Agriculture produce”
                            </h6>
                            <h6 className="fw-semibold mb-3">
                                Thus we strive to make good the adage
                            </h6>
                            <h6 className="fw-semibold mb-3">
                                ‘A Grain saved is A Grain produced’
                            </h6>
                        </div>
                    </div>

                    {/* RIGHT CARDS */}
                    <div className="col-md-6 m-0" data-aos="fade-left" data-aos-delay="200">
                        <div className="row g-4">
                            <img
                                src={web2}
                                alt="Office 2"
                                className="img-fluid rounded shadow"
                            />
                        </div>
                    </div>


                </div>
                <p className="text-muted">
                    The Tamil Nadu Warehousing Corporation provides scientific Warehousing
                    facilities for agriculture produce, processed food grain, other agri-related
                    Warehousing needs- fertilizers, poultry feed etc., as well as for non-agricultural
                    commodities such as cement, paper, paints, machinery etc.,
                    <br />
                    <br />
                    As a facilitating supplementary activity the TNWC also takes up Handling and Transport
                    operations, through an e-tendering process, at the request of its depositors.
                    <br />
                    <br />
                    Further due to its variegated activities relating to storage and maintenance of agriculture
                    and agri-related commodities, the TNWC has developed expertise in Pest Control Management
                    and provides Pest Control Services to organizations in both the public and private sectors
                    including Government Offices, Hospitals, Hostels, Courts etc.,
                    <br />
                    <br />
                    The Corporation strives hard to provide Quality Warehousing Services through its dedicated
                    employees and is proud to disclose the fact that TNWC has been consistently generating profit
                    by providing state of the art Warehousing services to both public and private sector clients.
                    Enhancing Quality Services is our Vision.
                </p>
                <div className="text-center mt-4">
                    <span className="badge fs-6 px-4 py-2" style={{ background: "#0A2158" }}>
                        We assure “Safe Storage and Quality Service”
                    </span>
                </div>

            </div>
            {/* <div className=" text-danger py-4 px-5">
                <hr className="w-100 opacity-100" style={{ borderColor: "rgba(9, 26, 58, 1)" }} />
            </div> */}
        </section>
    );
}

export default Home